import React from 'react';
import PropTypes from 'prop-types';
import { FDImage } from '@facet-wealth/design';
import fr from 'facet-rest';

export const DialogImage = ({ value }) => {
  let aspectRatio;
  let altText;
  let url = value;
  // If this is a resource, find the image relationship on it
  if (url && typeof url === 'object' && url.relationship) {
    url = url.relationship(fr.relationships.image.name);
  }
  // If this is a relationship (either because of the previous if statement or because a relationship was passed in directly), then we can extract some meta out of it + the URL
  if (url && typeof url === 'object' && url.link) {
    aspectRatio = url.meta('aspectRatio');
    altText = url.meta('altText');
    url = url.link('related')?.url();
  }

  // The URL relationship could have been missing, in which case we shouldn't render an image
  if (!url) {
    return null;
  }
  // If alt text is missing, FD will blow up. Give an empty string default to avoid that.
  // MDN suggests using empty string for alt text if an image is purely decorative. Since all
  // of the images used so far in our dialogs are purely decorative this is a safe default.
  if (!altText) {
    altText = '';
  }
  // If aspect ratio is missing, we can have a janky experience. Give a default aspect ratio to avoid that
  if (!aspectRatio) {
    aspectRatio = '446/174';
  }

  return (
    <FDImage alt={altText} src={url} width="100%" aspectRatio={aspectRatio} />
  );
};

DialogImage.defaultProps = {
  value: undefined,
};

DialogImage.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};
